/**
 * 类目轴 (折线图 boundaryGap：false)
 * @param xAxisName 
 * @param xAxisDatas 
 * @param style 
 */
export const getXaxisOfCategory = function (xAxisName: string, xAxisDatas: any[], style: any) {
  let paramJsonObj = [
    {
      name: xAxisName,
      nameTextStyle: {
        fontSize: style.fontSize
      },
      type: "category",
      boundaryGap: false,
      data: xAxisDatas,
      // X轴线设置
      axisLine: {
        show: true,
        lineStyle: {
          opacity: 0.8,
          color: "#ccd6eb",
          width: 1,
        },
      },
      // X轴线刻度设置
      axisTick: {
        show: false,
        length: 8,
        lineStyle: {
          opacity: 0.8,
          color: "#ccd6eb",
          width: 1,
        },
        alignWithLabel: true,
      },
      // X轴线标签设置
      axisLabel: {
        show: true,
        color: "#666666",
        fontSize: style.fontSize - 1,
      },
      splitLine: {
        show: false
      }
    },
  ]
  return paramJsonObj;
}

export const getDefaultXaxisOfCategory = function (style: any) {
  let paramJsonObj =
  {
    name: "",
    nameTextStyle: {
      fontSize: style.fontSize
    },
    type: "category",
    boundaryGap: false,
    data: [],
    // X轴线设置
    axisLine: {
      show: true,
      lineStyle: {
        opacity: 0.8,
        color: "#ccd6eb",
        width: 1,
      },
    },
    // X轴线刻度设置
    axisTick: {
      show: true,
      length: 8,
      lineStyle: {
        opacity: 0.8,
        color: "#ccd6eb",
        width: 1,
      },
      alignWithLabel: true,
    },
    // X轴线标签设置
    axisLabel: {
      show: true,
      color: "#666666",
      fontSize: style.fontSize - 1,
    },
    splitLine: {
      show: false
    }
  }
  return paramJsonObj;
}
/**
 * 带刻度线的X轴类目轴
 * @param style 
 * @param xAxisName x轴名
 * @param xAxisDatas xData
 */
export const getXaxisOfCategoryTick = function (style, xAxisName: string = "", xAxisDatas: any[] = []) {
  let paramJsonObj = [
    {
      name: xAxisName,
      type: "category",
      boundaryGap: false,
      data: xAxisDatas,
      // X轴线设置
      axisLine: {
        show: true,
        lineStyle: {
          opacity: 0.8,
          color: "#ccd6eb",
          width: 1,
        },
      },
      // X轴线刻度设置
      axisTick: {
        show: true,
        length: 8,
        lineStyle: {
          opacity: 0.8,
          color: "#ccd6eb",
          width: 1,
        },
        alignWithLabel: true,
      },
      // X轴线标签设置
      axisLabel: {
        show: true,
        color: "#666666",
        fontSize: style.fontSize - 1,
      },
      splitLine: {
        show: false
      }
    },
  ]
  return paramJsonObj;
}
/**
 * 带有刻度线类目轴（默认）（废弃）
 * @param xAxisName 
 * @param xAxisDatas 
 * @deprecated 
 */
export const getXaxisOfCategoryTickDefault = (style) => {
  let paramJsonObj = [
    {
      name: '',
      nameTextStyle: {
        fontSize: style.fontSize
      },
      type: "category",
      data: [],
      boundaryGap: false,
      // X轴线设置
      axisLine: {
        show: true,
        lineStyle: {
          opacity: 0.8,
          color: "#ccd6eb",
          width: 1,
        },
      },
      // X轴线刻度设置
      axisTick: {
        show: true,
        length: 8,
        lineStyle: {
          opacity: 0.8,
          color: "#ccd6eb",
          width: 1,
        },
        alignWithLabel: true,
      },
      // X轴线标签设置
      axisLabel: {
        show: true,
        color: "#666666",
        fontSize: style.fontSize - 1,
      },
      splitLine: {
        show: false
      }
    },
  ]
  return paramJsonObj;
}
/**
 * 无数据的X轴类目轴
 * @param style 
 * @param xAxisName 
 */
export const getXaxisOfCategoryNoXDatas = function (style, xAxisName?: string) {
  let paramJsonObj = [
    {
      name: xAxisName,
      nameTextStyle: {
        fontSize: style.fontSize
      },
      type: "category",
      // X轴线设置
      axisLine: {
        show: true,
        lineStyle: {
          opacity: 0.8,
          color: "#ccd6eb",
          width: 1,
        },
      },
      // X轴线刻度设置
      axisTick: {
        show: true,
        length: 8,
        lineStyle: {
          opacity: 0.8,
          color: "#ccd6eb",
          width: 1,
        },
        alignWithLabel: true,
      },
      // X轴线标签设置
      axisLabel: {
        show: true,
        color: "#666666",
        fontSize: style.fontSize - 1,
      },
      splitLine: {
        show: false
      }
    },
  ]
  return paramJsonObj;
}

// 时间轴
export const getXaxisOfTime = function (xAxisName: string) {
  let paramJsonObj = [
    {
      name: xAxisName,
      type: "time",
      minInterval: 1,
      maxInterval: 3600 * 24 * 100,
      // X轴线设置
      axisLine: {
        show: true,
        lineStyle: {
          opacity: 0.8,
          color: "#ccd6eb",
          width: 1,
        },
      },
      // X轴线刻度设置
      axisTick: {
        show: true,
        length: 8,
        lineStyle: {
          opacity: 0.8,
          color: "#ccd6eb",
          width: 1,
        },
        alignWithLabel: true,
      },
      // X轴线标签设置
      axisLabel: {
        show: true,
        color: "#666666",
        fontSize: 11,
      },
      splitLine: {
        show: false,
      },
    },
  ];
  return paramJsonObj;
};
/**
 * 类目轴x轴 (柱状图 boundary：true)
 * @param style 
 * @param data x轴数据
 * @param name x轴名称
 */
export function getCategoryXAxis(style, data: string[] = [], name: string = '') {
  const categoryAxis = [{
    name: name,
    nameTextStyle: {
      fontSize: style.fontSize
    },
    type: 'category',
    axisTick: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: '#ccd6ed'
      }
    },
    axisLabel: {
      fontSize: style.fontSize - 1,
      color: '#666'
    },
    data: data
  }]
  return categoryAxis
}
/**
 * x轴值轴
 * @param style 
 * @param axisName 
 */
export function getValueXAxis(style, axisName: string = "") {
  const valueAxis = [{
    type: 'value',
    name: axisName,
    nameLocation: 'center',
    nameTextStyle: {
      color: '#666666',
      fontSize: style.fontSize
    },
    nameGap: 30,
    axisLine: {
      show: false
    },
    min: function (value) {
      if (value.min % 10 !== 0) {
        return Math.floor(value.min / 10) * 10;
      } else {
        return value.min;
      }
    },
    label: {
      show: true,
    },
    axisTick: {
      show: false,
      length: 10
    },
    axisLabel: {
      fontSize: style.fontSize - 1,
      color: '#666666'
    },
    splitLine: {
      lineStyle: {
        color: '#e6e6e6'
      }
    }
  }]
  return valueAxis
}

export function getDefaultXaxisOfValue(style) {
  let valueAxis = {
    type: 'value' as 'value' | 'category' | 'time' | 'log',
    name: '',
    nameLocation: 'center' as 'center' | 'middle' | 'start' | 'end',
    nameTextStyle: {
      color: '#666666',
      fontSize: style.fontSize
    },
    nameGap: 30,
    axisLine: {
      show: false
    },
    min: function (value) {
      if (value.min % 10 !== 0) {
        return Math.floor(value.min / 10) * 10;
      } else {
        return value.min;
      }
    },
    label: {
      show: true,
    },
    axisTick: {
      show: false,
      length: 10
    },
    axisLabel: {
      fontSize: style.fontSize - 1,
      color: '#666666'
    },
    splitLine: {
      lineStyle: {
        color: '#e6e6e6'
      }
    }
  }
  return valueAxis
}
/**
 * x轴值轴 金字塔值轴
 * @param style 
 * @param axisName 
 */
export function getPyramidValueAxis(style, axisName: string = "") {
  const valueAxis = [{
    type: 'value',
    name: axisName,
    nameLocation: 'center',
    nameTextStyle: {
      color: '#666666',
      fontSize: style.fontSize
    },
    nameGap: 30,
    axisLine: {
      show: false
    },
    label: {
      show: true,
    },
    axisTick: {
      show: false,
      length: 10
    },
    axisLabel: {
      fontSize: style.fontSize - 1,
      color: '#666666',
      formatter: function (value) {
        return Math.abs(value)
      }
    },
    splitLine: {
      lineStyle: {
        color: '#e6e6e6'
      }
    }
  }]
  return valueAxis

}

//todo 声学分析图x
export const getXaxisOfNoiseAnalysisLine = (interval: number, xdata, formatter?) => {
  const xAxis = [
    {
      axisLabel: {
        rotate: 30,
        interval: interval,
        formatter: formatter
          ? formatter
          : function (data) {
            let valueText = '';
            if (data.length > 5) {
              valueText = data.substring(0, 5) + '...'
            } else {
              valueText = data
            }
            return valueText;
          },
        textStyle: {
          fontSize: '100%'
        }
      },
      name: '',
      splitLine: { show: true },
      data: xdata
    },
    {
      data: xdata,
      gridIndex: 1,
      axisLabel: {
        interval: interval,
        formatter: function () {
          return "";
        },
        textStyle: {
          fontSize: '100%'
        }
      },
      splitLine: { show: true },
      axisTick: { show: false },
    },
    {
      gridIndex: 1,
    }
  ]
  return xAxis
}

//todo 声学分析下拉图x
export const getXaxisOfNoiseDropLine = (xdata, formatter?) => {
  let xAxis = [{
    name: '',
    type: "category",
    boundaryGap: false,
    data: xdata,
    splitNumber: 3,
    // X轴线设置
    axisLine: {
      show: true,
      textStyle: {
        fontSize: '100%'
      },
      lineStyle: {
        opacity: 0.8,
        color: "#ccd6eb",
        width: 1,
      },
    },
    // X轴线刻度设置
    axisTick: {
      show: true,
      length: 8,
      lineStyle: {
        opacity: 0.8,
        color: "#ccd6eb",
        width: 1,
      },
      alignWithLabel: true,
    },
    // X轴线标签设置
    axisLabel: {
      show: true,
      color: "#666666",
      rotate: 0,
      formatter: formatter
        ? formatter
        : function (data) {
          let valueText = '';
          if (data.length > 5) {
            valueText = data.substring(0, 5) + '...'
          } else {
            valueText = data
          }
          return valueText;
        },
    },
    splitLine: {
      show: false
    }
  }]
  return xAxis;
}

//todo 噪声事件波形图
export const getXaxisOfNoiseEventWave = (xdata, interval: number, formatter?) => {
  let xAxis = [{
    name: '',
    type: "category",
    boundaryGap: false,
    data: xdata,
    splitNumber: 3,
    // X轴线设置
    axisLine: {
      show: true,
      textStyle: {
        fontSize: '100%'
      },
      lineStyle: {
        opacity: 0.8,
        color: "#ccd6eb",
        width: 1,
      },
    },
    // X轴线刻度设置
    axisTick: {
      show: true,
      length: 8,
      lineStyle: {
        opacity: 0.8,
        color: "#ccd6eb",
        width: 1,
      },
      alignWithLabel: true,
    },
    // X轴线标签设置
    axisLabel: {
      show: true,
      rotate: 0,
      interval: interval,
      color: "#666666",
      formatter: formatter
        ? formatter
        : function (data) {
          let valueText = '';
          if (data.length > 5) {
            valueText = data.substring(0, 5) + '...'
          } else {
            valueText = data
          }
          return valueText;
        },
    },
    splitLine: {
      show: false
    }
  }]
  return xAxis;
}